import {
  type Modality,
  type PickUpInStoreModality,
} from '@/infra/services/catalog/product/get-shipments/model';

function pluralize(deadline: number, type: 'hour' | 'day') {
  if (type === 'hour') {
    return `${deadline} ${deadline > 1 ? 'horas' : 'hora'}`;
  }

  return `${deadline} ${deadline > 1 ? 'dias' : 'dia'}`;
}

export default function getModalityMessage(
  modality: Modality | PickUpInStoreModality
): {
  prefix?: string;
  main?: string;
  label: string;
} {
  const { type } = modality;

  const deadline =
    type === 'pick_up_in_store' ? modality.delayTime : modality.deadline;

  if (type === 'pick_up_in_store') {
    return {
      label: 'Retirada na loja',
      prefix: 'em',
      main: pluralize(deadline, 'hour'),
    };
  }

  if (type === 'scheduled' || type === 'marketplace_scheduled') {
    return {
      label: 'Agende a entrega',
    };
  }

  if (type === 'express' || type === 'marketplace_express') {
    const isToday = deadline === 0;
    const isFastDelivery = type === 'express' && modality.expressDeliveryDay;

    if (isFastDelivery) {
      return {
        label: 'Entrega Expressa',
      };
    }

    if (isToday) {
      return {
        label: 'Entrega Expressa',
        prefix: 'no',
        main: 'mesmo dia',
      };
    }

    return {
      label: 'Entrega Expressa',
      prefix: 'em até',
      main: pluralize(deadline, 'day'),
    };
  }

  return {
    label: 'Entrega',
    prefix: 'em até',
    main: pluralize(deadline, 'day'),
  };
}
